/* eslint-disable no-unused-vars */
export function DateFormatter(dateString) {
  var date = "";
  const options = { year: "numeric", month: "short", day: "numeric" };
  if (dateString != null) {
    date = new Date(Date.parse(dateString)).toLocaleDateString(
      "en-GB",
      options
    );
    return date;
  } else {
    return "--";
  }
}

function getMonthName(val) {
  var month = []
  month[0] = "January";
  month[1] = "February";
  month[2] = "March";
  month[3] = "April";
  month[4] = "May";
  month[5] = "June";
  month[6] = "July";
  month[7] = "August";
  month[8] = "September";
  month[9] = "October";
  month[10] = "November";
  month[11] = "December";
  return month[val]
}

function getShortMonthName(val) {
  var month = []
  month[0] = "Jan";
  month[1] = "Feb";
  month[2] = "Mar";
  month[3] = "Apr";
  month[4] = "May";
  month[5] = "Jun";
  month[6] = "Jul";
  month[7] = "Aug";
  month[8] = "Sept";
  month[9] = "Oct";
  month[10] = "Nov";
  month[11] = "Dec";
  return month[val]
}

export function ShortDateFormatter(dateString) {
  if (dateString != null) {
    const date = new Date(Date.parse(dateString))
    return `${date.getDate()} ${getShortMonthName(date.getMonth())} ${date.getFullYear()}`
  } else {
    return "--";
  }

}
/* eslint-enable no-unused-vars */
